import {
  GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_REQUEST,
  GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_SUCCESS,
  GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_FAILURE,
  POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_REQUEST,
  POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_SUCCESS,
  POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_FAILURE,
  GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST,
  GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS,
  GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE,
  LOG_OUT_SUCCESS,
} from "../../constants/ActionTypes";
import * as errMessages from "../../constants/ErrorMessages";
import * as messages from "../../constants/Messages";
import { formatErrorMessage } from "../../utils/utils";
import { isExpiredAccessError } from "../../utils/salesforceUtils";

const initialState = {
  errorMessage: "",
  shortMessage: "",
  successMessage: "",
  expiredAccessError: false,
  isLoadingFields: false,
  eventFields: {},
  isConfiguring: false,
  mapping: {},
  isLoadingMapping: false,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: "",
    successMessage: "",
    errorMessage: "",
    expiredAccessError: false,
  };

  let eventFields;
  switch (action.type) {
    case GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_REQUEST:
      return {
        ...state,
        isLoadingFields: true,
      };
    case GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_SUCCESS:
      eventFields = {};
      Object.values(action.payload.eventFields).forEach(
        (item) => (eventFields[item.name] = item)
      );

      return {
        ...state,
        isLoadingFields: false,
        eventFields: eventFields,
      };
    case GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_FAILURE:
      return {
        ...state,
        isLoadingFields: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
      };
    case POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_REQUEST:
      return {
        ...state,
        isConfiguring: true,
      };
    case POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_SUCCESS:
      return {
        ...state,
        shortMessage: messages.SAVE_SUCCESS,
        isConfiguring: false,
      };
    case POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_FAILURE:
      return {
        ...state,
        isConfiguring: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_POST_SALESFORCE_CONFIG_FAILURE
        ),
        expiredAccessError: isExpiredAccessError(action.payload.error),
      };
    case GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST:
      return {
        ...state,
        isLoadingMapping: true,
      };
    case GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS:
      return {
        ...state,
        mapping: action.payload.mapping,
        isLoadingMapping: false,
      };
    case GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE:
      return {
        ...state,
        isLoadingMapping: false,
        mapping: initialState.mapping,
      };
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/salesforceTimelineStatusSetting.js